export class MarginInfoGroup {
}
